import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

export function DeleteCarePrincipalModal() {
  const { handleSubmit } = useForm();
  const listItem = useSelector((state: any) => state.carePrincipal.item);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const carePrincipalId = useSelector(
    (state: any) => state.carePrincipal.carePrincipal.carePrincipalId
  );

  const onSubmit = () => {
    dispatch({
      type: "DELETE_CARE_PRINCIPAL_ACCESS",
      listItem,
      carePrincipalId,
    });
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      open={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={1} sx={{ paddingBottom: 2, maxWidth: "40rem" }}>
          {listItem.idType === "System" ? (
            <div>
              <DialogTitle id="alert-dialog-title">
                {t("jobSettings.deleteSystemAccess")}
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  {t("jobSettings.confirmSystemDelete")}
                </DialogContentText>
              </DialogContent>
            </div>
          ) : (
            <div>
              <DialogTitle id="alert-dialog-title">
                {t("jobSettings.deleteCareProviderAccess")}
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  {t("jobSettings.confirmCareProviderDelete")}
                </DialogContentText>
              </DialogContent>
            </div>
          )}
        </Stack>

        <DialogActions>
          <Button
            variant="contained"
            onClick={() => dispatch({ type: "MODAL_CANCEL" })}
          >
            {t("cancel")}
          </Button>
          <Button variant="contained" color="error" type="submit" autoFocus>
            {t("remove")}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
